import { render, staticRenderFns } from "./DealershipApplicationsCommentsList.vue?vue&type=template&id=13247830"
import script from "./DealershipApplicationsCommentsList.vue?vue&type=script&lang=js"
export * from "./DealershipApplicationsCommentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports